module.exports = __webpack_public_path__ + "img/1.10483234.jpg";